import { AuthGuard } from '@onesource/components';
import { Outlet, createFileRoute } from '@tanstack/react-router';
import { DashboardLayout } from 'src/layouts/dashboard';

export const Route = createFileRoute('/_protected')({
  component: () => {
    return (
      <DashboardLayout>
        <AuthGuard>
          <Outlet />
        </AuthGuard>
      </DashboardLayout>
    );
  },
});
